import React from "react";
import { Button } from "semantic-ui-react";
import { Trans } from "react-i18next";

function CancelButton({ isOnWaitingList, canCancel, onSubmit }) {
  return (
    <Button disabled={!canCancel} onClick={onSubmit} negative>
      {isOnWaitingList ? (
        <Trans i18nKey="coursePlan.registration.actions.cancelWaitingList" />
      ) : (
        <Trans i18nKey="coursePlan.registration.actions.cancelDirect" />
      )}
    </Button>
  );
}

CancelButton.displayName = "coursePlan/cancel/CancelButton";

export default React.memo(CancelButton);
